import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from '@/i18n/pt.ts';
import en from '@/i18n/en.ts';
import de from '@/i18n/de.ts';
import es from '@/i18n/es.ts';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#34D0B4',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#373A42',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  lang: {
    locales: {
      pt,
      en,
      de,
      es,
    },
  },
});

export default vuetify;
